import { transparentize } from 'polished'
import { ReactNode } from 'react'
import { AlertTriangle } from 'react-feather'
import styled, { css } from 'styled-components'
import { Z_INDEX } from 'theme/zIndex'

import { AutoColumn } from '../Column'

export const PageWrapper = styled.div`
  padding: 68px 8px 0px;
  max-width: 480px;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.md}px`}) {
    padding-top: 48px;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.sm}px`}) {
    padding-top: 20px;
  }
`

// Mostly copied from `AppBody` but it was getting too hard to maintain backwards compatibility.
export const LaunchpadWrapper = styled.main<{ isDark?: boolean }>`
  position: relative;
  background: ${({ theme }) => theme.surface1};
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.surface3};
  padding: 8px;
  padding-top: 12px;
  box-shadow: ${({ isDark }) =>
    `0px 0px 10px 0px rgba(239, 220, 139, ${isDark ? '50' : '50'}), 0px 40px 120px 0px rgba(239, 220, 139, ${
      isDark ? '50' : '50'
    })`};
  z-index: ${Z_INDEX.default};
  transition: transform 250ms ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.surface3};
  }
`

// Mostly copied from `AppBody` but it was getting too hard to maintain backwards compatibility.
export const SwapWrapper = styled.main<{ isDark?: boolean; isMiner?: boolean }>`
  position: relative;
  background: ${({ theme }) => theme.surface1};
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.surface3};
  padding: 8px;
  padding-top: 12px;
  box-shadow: ${({ isDark, isMiner }) =>
    isMiner
      ? `0px 0px 10px 0px rgba(239, 220, 139, ${isDark ? '50' : '50'}), 0px 40px 120px 0px rgba(239, 220, 139, ${
          isDark ? '50' : '50'
        })`
      : `0px 0px 10px 0px rgba(70, 115, 250, ${isDark ? '0.08' : '0.04'}), 0px 40px 120px 0px rgba(70, 115, 250, ${
          isDark ? '0.18' : '0.12'
        })`};
  z-index: ${Z_INDEX.default};
  transition: transform 250ms ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.surface3};
  }
`

// Mostly copied from `AppBody` but it was getting too hard to maintain backwards compatibility.
export const RingXWrapper = styled.main<{ isDark?: boolean }>`
  position: relative;
  background: ${({ theme }) => theme.surface1};
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.surface3};
  padding: 8px;
  padding-top: 12px;
  box-shadow: ${({ isDark }) =>
    `0px 0px 10px 0px rgba(252, 224, 242, ${isDark ? '50' : '50'}), 0px 40px 120px 0px rgba(252, 224, 242, ${
      isDark ? '50' : '50'
    })`};
  z-index: ${Z_INDEX.default};
  transition: transform 250ms ease;
  &:hover {
    border: 1px solid ${({ theme }) => theme.surface3};
  }
`

export const ArrowWrapper = styled.div<{ clickable: boolean }>`
  border-radius: 12px;
  height: 40px;
  width: 40px;
  position: relative;
  margin-top: -18px;
  margin-bottom: -18px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ theme }) => theme.surface2};
  border: 4px solid;
  border-color: ${({ theme }) => theme.surface1};

  z-index: 2;
  ${({ clickable }) =>
    clickable
      ? css`
          :hover {
            cursor: pointer;
            opacity: 0.8;
          }
        `
      : null}
`

// styles
export const Dots = styled.span`
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
`

const SwapCallbackErrorInner = styled.div`
  background-color: ${({ theme }) => transparentize(0.9, theme.critical)};
  border-radius: 1rem;
  display: flex;
  align-items: center;
  font-size: 0.825rem;
  width: 100%;
  padding: 3rem 1.25rem 1rem 1rem;
  margin-top: -2rem;
  color: ${({ theme }) => theme.critical};
  z-index: -1;
  p {
    padding: 0;
    margin: 0;
    font-weight: 535;
  }
`

const SwapCallbackErrorInnerAlertTriangle = styled.div`
  background-color: ${({ theme }) => transparentize(0.9, theme.critical)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border-radius: 12px;
  min-width: 48px;
  height: 48px;
`

export function SwapCallbackError({ error }: { error: ReactNode }) {
  return (
    <SwapCallbackErrorInner>
      <SwapCallbackErrorInnerAlertTriangle>
        <AlertTriangle size={24} />
      </SwapCallbackErrorInnerAlertTriangle>
      <p style={{ wordBreak: 'break-word' }}>{error}</p>
    </SwapCallbackErrorInner>
  )
}

export const SwapShowAcceptChanges = styled(AutoColumn)`
  background-color: ${({ theme }) => transparentize(0.95, theme.accent1)};
  color: ${({ theme }) => theme.accent1};
  padding: 12px;
  border-radius: 12px;
  margin-top: 8px;
`
